import * as React from "react";

function SvgScopeAi(props, ref) {
  return (
    <svg
      id="ScopeAi_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x={0}
      y={0}
      viewBox="0 0 275 84"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".ScopeAi_svg__st0{fill:#1082b4}.ScopeAi_svg__st1{fill:#84cce9}"}
      </style>
      <g id="ScopeAi_svg__Scope-Final-01" transform="translate(22 15)">
        <path
          id="ScopeAi_svg__Fill-1"
          className="ScopeAi_svg__st0"
          d="M88.9 23.7c-.1-.3-.2-.7-.3-1.1-.2-.4-.4-.8-.8-1.2-.4-.4-.9-.7-1.4-.9-.6-.3-1.3-.4-2.2-.4-1.2 0-2.2.3-2.9 1-.7.6-1.1 1.4-1.1 2.1 0 .7.2 1.3.7 1.8.4.5 1.2.8 2.2 1l3.9.7c1.4.2 2.6.6 3.6 1.2s1.9 1.2 2.6 2c.7.8 1.2 1.6 1.6 2.6.4.9.5 1.9.5 3s-.2 2.3-.7 3.3c-.5 1.1-1.2 2.1-2.1 2.9-.9.9-2 1.5-3.4 2.1-1.3.5-2.9.8-4.6.8-2 0-3.7-.3-5.2-.9-1.4-.6-2.6-1.3-3.6-2.2-1-.9-1.7-1.9-2.2-3-.5-1.1-.8-2.1-.9-3.2l5.9-1.4c.1.7.2 1.3.5 1.9.3.6.6 1.1 1.1 1.6.5.4 1.1.8 1.8 1.1.7.3 1.6.4 2.6.4 1.3 0 2.3-.3 3-.8.7-.6 1.1-1.3 1.1-2.2 0-.7-.3-1.4-.8-1.9-.6-.5-1.3-.8-2.3-1l-4-.7c-2.5-.5-4.4-1.5-5.8-3-1.4-1.5-2.1-3.4-2.1-5.5 0-1.4.3-2.6.8-3.8.6-1.1 1.3-2.1 2.3-2.9 1-.8 2.1-1.5 3.3-1.9 1.2-.5 2.6-.7 4-.7 1.8 0 3.3.2 4.6.7 1.3.5 2.3 1.1 3.2 1.9.8.7 1.5 1.6 1.9 2.5.4.9.7 1.8.9 2.6l-5.7 1.5"
        />
        <path
          id="ScopeAi_svg__Fill-2"
          className="ScopeAi_svg__st0"
          d="M108.5 28.8c-.7 0-1.3.1-1.8.3-.6.2-1 .5-1.5 1-.4.4-.8 1-1 1.6-.2.6-.4 1.3-.4 2.2 0 .8.1 1.5.4 2.1.3.6.6 1.1 1 1.6.4.4.9.8 1.5 1 .6.2 1.2.3 1.8.3 1.2 0 2.1-.3 2.8-.9.7-.6 1.1-1.3 1.4-2.1l5.5 1.7c-.2.9-.6 1.8-1.1 2.6-.5.8-1.2 1.6-2 2.2-.8.7-1.8 1.2-2.9 1.6-1.1.4-2.3.6-3.7.6-1.5 0-2.9-.3-4.3-.8-1.3-.5-2.5-1.3-3.4-2.2-1-1-1.8-2.1-2.3-3.4-.6-1.3-.9-2.7-.9-4.3 0-1.6.3-3 .8-4.3s1.3-2.5 2.3-3.4c1-1 2.1-1.7 3.4-2.2 1.3-.5 2.7-.8 4.2-.8 1.4 0 2.6.2 3.8.6 1.1.4 2.1.9 2.9 1.6.8.7 1.5 1.4 2 2.3.5.9.9 1.7 1.1 2.6l-5.6 1.7c-.1-.4-.3-.8-.5-1.1-.2-.4-.5-.7-.8-1-.3-.3-.7-.5-1.2-.7s-.9-.4-1.5-.4"
        />
        <path
          id="ScopeAi_svg__Fill-3"
          className="ScopeAi_svg__st0"
          d="M131.2 38.8c.6 0 1.2-.1 1.7-.3.5-.2 1-.5 1.4-.9.4-.4.8-.9 1-1.6.3-.6.4-1.4.4-2.2 0-.8-.1-1.6-.4-2.2-.3-.6-.6-1.2-1-1.6-.4-.4-.9-.7-1.4-.9-.5-.2-1.1-.3-1.7-.3-.6 0-1.1.1-1.7.3-.6.2-1 .5-1.5.9-.4.4-.8.9-1 1.6-.3.6-.4 1.4-.4 2.2 0 .8.1 1.6.4 2.2.3.6.6 1.2 1 1.6.4.4.9.7 1.5.9.5.2 1.1.3 1.7.3zm0-15.8c1.5 0 2.9.3 4.2.8 1.3.5 2.4 1.3 3.4 2.2 1 1 1.7 2.1 2.3 3.4.6 1.3.8 2.7.8 4.3 0 1.6-.3 3-.8 4.3-.6 1.3-1.3 2.5-2.3 3.4-1 1-2.1 1.7-3.4 2.2-1.3.5-2.7.8-4.2.8s-2.9-.3-4.2-.8c-1.3-.5-2.4-1.3-3.4-2.2-1-1-1.7-2.1-2.3-3.4-.6-1.3-.8-2.8-.8-4.3 0-1.6.3-3 .8-4.3.6-1.3 1.3-2.4 2.3-3.4 1-1 2.1-1.7 3.4-2.2 1.2-.5 2.7-.8 4.2-.8z"
        />
        <path
          id="ScopeAi_svg__Fill-4"
          className="ScopeAi_svg__st0"
          d="M161.3 33.8c0-.8-.1-1.6-.4-2.2-.2-.6-.6-1.1-1-1.6-.4-.4-.9-.7-1.5-.9-.6-.2-1.1-.3-1.7-.3-.6 0-1.2.1-1.7.3-.6.2-1 .5-1.5.9-.4.4-.8.9-1 1.6-.2.6-.4 1.4-.4 2.2 0 .8.1 1.6.4 2.2.2.6.6 1.1 1 1.6.4.4.9.7 1.5 1 .6.2 1.1.3 1.7.3.6 0 1.2-.1 1.7-.3.6-.2 1.1-.5 1.5-.9.4-.4.8-1 1-1.6.2-.7.4-1.5.4-2.3zM146 51.7v-28h6v2.1c.4-.7 1.2-1.2 2.2-1.8 1-.5 2.3-.8 3.8-.8s2.8.3 4 .8c1.2.5 2.2 1.3 3 2.2.8.9 1.4 2.1 1.9 3.3.4 1.3.7 2.7.7 4.2 0 1.6-.2 3-.7 4.3-.5 1.3-1.1 2.4-2 3.4-.9.9-1.9 1.7-3.1 2.2-1.2.5-2.5.8-3.9.8-1.3 0-2.4-.2-3.4-.6-1-.4-1.7-.9-2.1-1.4v9.3H146z"
        />
        <path
          id="ScopeAi_svg__Fill-5"
          className="ScopeAi_svg__st0"
          d="M184.2 31.4c0-.4-.1-.8-.3-1.2-.1-.4-.4-.8-.7-1.1-.3-.3-.7-.6-1.2-.8-.5-.2-1.1-.3-1.9-.3-.7 0-1.2.1-1.7.3-.5.2-.9.5-1.2.8-.3.3-.6.7-.8 1.1-.2.4-.3.8-.3 1.2h8.1zm5.6 6.7c-.2.9-.6 1.7-1.1 2.5-.5.8-1.2 1.5-2 2.1s-1.7 1-2.8 1.4c-1 .3-2.2.5-3.5.5-1.4 0-2.7-.2-4-.7-1.3-.5-2.4-1.2-3.4-2.1-1-.9-1.8-2.1-2.3-3.4-.6-1.3-.9-2.9-.9-4.6 0-1.6.3-3.1.8-4.4.6-1.3 1.3-2.4 2.2-3.4.9-.9 2-1.6 3.2-2.1 1.2-.5 2.5-.8 3.8-.8 3.2 0 5.6.9 7.4 2.7 1.8 1.8 2.7 4.4 2.7 7.7v1.2c0 .4-.1.6-.1.7h-14.1c0 .6.2 1.1.4 1.6.3.5.6.9 1 1.2.4.4.9.6 1.4.8.5.2 1.1.3 1.7.3 1.1 0 2-.2 2.7-.7.6-.5 1.1-1.1 1.4-1.9l5.5 1.4z"
        />
        <path
          id="ScopeAi_svg__Fill-6"
          className="ScopeAi_svg__st1"
          d="M202.8 32.2h7l-3.5-10-3.5 10zm9.1 5.9h-11.2l-2.1 5.9h-6.8l10.9-29h7.5L221 43.9h-7l-2.1-5.8z"
        />
        <path
          id="ScopeAi_svg__Fill-7"
          className="ScopeAi_svg__st1"
          d="M224.5 43.9h6.6V15h-6.6z"
        />
        <path
          id="ScopeAi_svg__Fill-8"
          className="ScopeAi_svg__st0"
          d="M53.6 27.1c0 14.7-11.9 26.5-26.5 26.5C12.4 53.6.6 41.7.6 27.1S12.4.6 27 .6c14.7 0 26.6 11.8 26.6 26.5"
        />
        <path
          id="ScopeAi_svg__Fill-9"
          d="M43.3 26.7c-.2-2.9-2.7-5.2-5.7-5.2H18c-.3 0-.5-.4-.3-.6l1.2-1.2c.3-.3.8-.4 1.3-.2 2.1 1.1 4.8.8 6.5-1 2-2.1 2.1-5.5.1-7.6-2.1-2.3-5.8-2.4-8-.2-1.8 1.8-2.1 4.4-1 6.5.2.4.2.9-.2 1.3l-2.9 2.9c-.4.4-.8.7-1.3.9-1.8 1-2.9 3-2.8 5.2.2 2.9 2.7 5.2 5.7 5.2h19.6c.3 0 .5.4.3.6L35 34.5c-.3.3-.8.4-1.3.2-2.1-1.1-4.8-.8-6.5 1-2 2.1-2.1 5.5-.1 7.6 2.1 2.3 5.8 2.4 8 .2 1.8-1.8 2.1-4.4 1-6.5-.1-.5-.1-1 .3-1.3l2.9-2.9c.4-.4.8-.7 1.3-.9 1.7-1 2.8-3 2.7-5.2"
          fill="#fffffe"
        />
      </g>
      <image
        width={515}
        height={515}
        xlinkHref="Screen Shot 2018-02-15 at 3.59.51 AM.png"
        transform="matrix(.5 0 0 .5 -333 -90)"
        overflow="visible"
      />
    </svg>
  );
}

export default React.forwardRef(SvgScopeAi);
